module.exports = __webpack_public_path__ + "static/media/aosc.39a62f18.jpg";